/** @format */

export const initialState = {
  info: {},
  refetchTaskCount: () => {},
  refetchDebtCount: () => {},  
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'setInfo':
      return { ...state, info: action.payload };
    case 'setRefetchTaskCount':
      return { ...state, refetchTaskCount: action.payload };
    case 'setRefetchDebtCount':      // yangi action
      return { ...state, refetchDebtCount: action.payload };
    default:
      return state;
  }
};
